import {
    UserDisplayedWidgetClassEnum,
    useDismissMyCourseGuidanceBannerMutation,
    useGetMyCourseGuidanceBannerQuery,
} from '@lingoda/monolith-graphql';
import { useSelector, useWidgetPersistentState } from '@lingoda/hooks';
import { studentSelector } from '@lingoda/students';

export const useMyCourseGuidanceBanner = () => {
    const student = useSelector(studentSelector);
    const isNewStudent = student?.isNewStudent;

    const { isHidden: wasDismissed, close } = useWidgetPersistentState(
        'MyCourseGuidanceBannerHidden',
    );
    const { data } = useGetMyCourseGuidanceBannerQuery();
    const [dismissMyCourseGuidanceBannerMutation] = useDismissMyCourseGuidanceBannerMutation();

    const isVisible =
        !wasDismissed &&
        !!isNewStudent &&
        !!data?.userWidgets?.includes(UserDisplayedWidgetClassEnum.MyCourseGuidanceBanner) &&
        // Add option to hide banner for e2e, instead of manually skip it in every test
        localStorage.getItem('my_course_guidance_banner') !== 'hidden';

    const handleDismiss = async () => {
        close();
        await dismissMyCourseGuidanceBannerMutation();
    };

    return {
        isVisible,
        handleDismiss,
    };
};
